"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = function _default() {
  return (0, _styledComponents.css)(["background:transparent;color:inherit;border:none;font:inherit;line-height:normal;overflow:visible;width:auto;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;"]);
};

exports["default"] = _default;